<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row" ref="formContainer">
        <div class="col-lg-3">
          <ValidationObserver ref="form">
            <div class="form-group">
              <label for="" class="form-label">Nombre</label>
              <InputText
                v-model="form.name"
                rules="required"
                name="Nombre"
              ></InputText>
            </div>

            <div class="form-group">
              <label for="" class="form-label">Tipo de Documento</label>
              <InputSelect
                v-model="form.tipoDoc"
                name="Tipo de Documento"
                :options="containers.tiposDoc"
                label="nombre"
                :clearable="true"
                :rules="
                  String(form.numeroDoc || '').trim().length ? 'required' : ''
                "
              ></InputSelect>
            </div>

            <div class="form-group">
              <label for="" class="form-label">Número de Documento</label>
              <div class="form-row">
                <div class="col-10">
                  <InputText
                    v-model="form.numeroDoc"
                    :rules="(form.tipoDoc ? 'required|' : '') + 'max:15'"
                    name="Número de Documento"
                  ></InputText>
                </div>
                <div class="col-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm btn-icon"
                    @click="fetchRucDni"
                    :disabled="loading.rucdni"
                  >
                    <i class="fa fa-fw fa-search"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="" class="form-label">Dirección</label>
              <InputText v-model="form.direction" name="Dirección"></InputText>
            </div>
            <div class="form-group">
              <label for="" class="form-label">E-mail</label>
              <InputText
                v-model="form.email"
                name="E-mail"
                rules="email"
              ></InputText>
            </div>
            <div class="form-group">
              <div class="d-flex align-items-center">
                <div>
                  <input
                    id="checkPool"
                    type="checkbox"
                    v-model="form.credito"
                  />
                </div>
                <label for="checkPool" class="font-weight-bold mb-0 ml-2"
                  >Crédito</label
                >
              </div>
            </div>
            <div class="form-group text-right">
              <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
              >
                Nuevo
              </button>
              <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
              >
                Guardar
              </button>
            </div>
          </ValidationObserver>
        </div>
        <div class="col-lg-9">
          <Table
            :columns="containers.columns"
            :rows="containers.agencias"
            columnID="idAgencia"
          >
            <template #rowactions="{ row }">
              <template v-if="row.origen != 0">
                <button
                  class="btn btn-xs btn-icon btn-light-warning"
                  @click="onEdit(row)"
                >
                  <span class="fa fa-fw fa-pencil-alt"></span>
                </button>
                <button
                  class="btn btn-xs btn-icon btn-light-danger ml-2"
                  @click="onDelete(row)"
                >
                  <span class="fa fa-fw fa-trash-alt"></span>
                </button>
              </template>
              <button
                @click="onShowModalAgenciaContactos(row)"
                class="btn btn-xs btn-icon btn-light-primary ml-1"
              >
                <span class="fa fa-fw fa-list"></span>
              </button>
              <button
                @click="onShowModalAgenciaPax(row)"
                class="btn btn-xs btn-icon btn-light-success ml-1"
              >
                <span class="fa fa-fw fa-dollar-sign"></span>
              </button>
            </template>
            <template #rowcredito="{ val }">
              {{ val == 1 ? "Sí" : "No" }}
            </template>
          </Table>
        </div>
      </div>
    </div>
    <ModalAgenciaContactos
      v-if="containers.showModalAgenciaContactos"
      :agencia="containers.agencia"
      :show="containers.showModalAgenciaContactos"
      @close="onCloseAgenciaContactos"
    />
    <ModalAgenciaPax
      v-if="containers.showModalAgenciaTarifas"
      :agencia="containers.agencia"
      :show="containers.showModalAgenciaTarifas"
      @close="containers.showModalAgenciaTarifas = false"
    />
  </div>
</template>
<script>
import InputSelect from "../../../modules/shared/components/InputSelect.vue";
import InputText from "../../../modules/shared/components/InputText.vue";
import Table from "../../../modules/shared/components/Table.vue";
const ModalAgenciaContactos = () => import("@/modals/AgenciaContactos");
const ModalAgenciaPax = () => import("@/modals/AgenciaTarifas");
export default {
  layout: "app",
  components: {
    ModalAgenciaContactos,
    ModalAgenciaPax,
    Table,
    InputText,
    InputSelect
  },
  data() {
    return {
      form: {
        name: "",
        tipoDoc: "",
        numeroDoc: "",
        direction: "",
        email: "",
        credito: false
      },
      loading: {
        view: true,
        crud: false,
        rucdni: false,
      },
      containers: {
        id: null,
        agencias: [],
        tiposDoc: [],
        agencia: null,
        showModalAgenciaContactos: false,
        showModalAgenciaTarifas: false,
        columns: [
          {
            key: "actions",
            label: "",
            width: 110
          },
          {
            key: "nombre",
            label: "Nombre",
            width: 150
          },
          {
            key: "nombreAlterno",
            label: "Tipo Doc.",
            width: 80
          },
          {
            key: "ruc",
            label: "Nro. Documento",
            width: 150
          },
          {
            key: "credito",
            label: "Crédito",
            width: 50,
            body_class: "text-center"
          },
          {
            key: "contacto",
            label: "Contacto",
            width: 150
          },
          {
            key: "telefonoContacto",
            label: "Teléfono",
            width: 120
          },
          {
            key: "usuarioCreador",
            label: "UC",
            head_class: "text-center",
            width: 80
          },
          {
            key: "usuarioModif",
            label: "UM",
            head_class: "text-center",
            width: 80
          }
        ]
      }
    };
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading.view = true;

      let {
        data: { content }
      } = await this.axios.get("/mantenimiento/agencias");

      this.containers.agencias = content.agencias;
      this.containers.tiposDoc = content.tiposDoc;

      this.loading.view = false;
    },
    async onSave() {
      let vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          icon: "warning",
          title: "Revise y verifique los campos en rojo"
        });

        return;
      }

      let fd = {
        name: String(vm.form.name).trim(),
        tipoDoc: vm.form.tipoDoc?.idDocTipo || null,
        numeroDoc: String(vm.form.numeroDoc || "").trim(),
        direction: String(vm.form.direction || "").trim(),
        email: String(vm.form.email || "").trim(),
        credito: vm.form.credito ? 1 : 0,
        _method: "POST"
      };

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/agencias";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/agencias/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then(response => {
          if (vm.containers.id) {
            let findRow = vm.containers.agencias.find(
              item => item.idAgencia == vm.containers.id
            );

            findRow.nombre = fd.name;
            findRow.idDocTipo = vm.form.tipoDoc?.idDocTipo || "";
            findRow.nombreAlterno = vm.form.tipoDoc?.nombreAlterno || "";
            findRow.ruc = fd.numeroDoc || "";
            findRow.direccion = fd.direction || "";
            findRow.email = fd.email || "";
            findRow.credito = fd.credito;
            findRow.usuarioModif = vm.$store.state.user.codigo;
          } else {
            vm.containers.agencias.unshift({
              nombre: fd.name,
              idDocTipo: vm.form.tipoDoc?.idDocTipo || "",
              nombreAlterno: vm.form.tipoDoc?.nombreAlterno || "",
              ruc: fd.numeroDoc || "",
              direccion: fd.direction || "",
              email: fd.email || "",
              credito: fd.credito,
              idAgencia: response.data.content.id,
              usuarioCreador: vm.$store.state.user.codigo
            });

            vm.containers.id = response.data.content.id;
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch(error => {
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idAgencia;
      vm.form.name = pItem.nombre;
      vm.form.tipoDoc =
        vm.containers.tiposDoc.find(
          item => item.idDocTipo == pItem.idDocTipo
        ) || null;
      vm.form.numeroDoc = pItem?.ruc || "";
      vm.form.direction =
        pItem.direccion == "null" ? "" : pItem.direccion || "";
      vm.form.email = pItem.email || "";
      vm.form.credito = pItem.credito == 1 ? true : false;

      window.scrollTo(0, 0);
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
        "",
        "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/agencias/${pItem.idAgencia}`)
          .then(response => {
            let tempRegistros = [...vm.containers.agencias];
            vm.containers.agencias = tempRegistros.filter(
              item => item.idAgencia != pItem.idAgencia
            );
          })
          .catch(error => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.form.name = "";
      vm.form.tipoDoc = "";
      vm.form.numeroDoc = "";
      vm.form.direction = "";
      vm.form.email = "";
      vm.form.credito = false;
    },
    onShowModalAgenciaContactos(pItem) {
      this.containers.agencia = pItem;
      this.containers.showModalAgenciaContactos = true;
    },
    onShowModalAgenciaPax(pItem) {
      this.containers.agencia = pItem;
      this.containers.showModalAgenciaTarifas = true;
    },
    async onCloseAgenciaContactos(reload = false) {
      this.containers.showModalAgenciaContactos = false;

      if (reload) {
        await this.fetchData();
      }
    },
    async fetchRucDni() {
      const vm = this;

      const { tipoDoc, numeroDoc } = vm.form;

      const type = String(tipoDoc?.nombreAlterno).toLowerCase();
      const number = String(numeroDoc).trim();

      if (!number || !type) {
        vm.$toast.fire({
          icon: "warning",
          title:
            "Seleccione un Tipo de Documento e ingrese un Número de documento"
        });
        return;
      }

      vm.form.name = '';
      vm.form.direction = '';
      vm.loading.rucdni = true;

      try {
        const response = await vm.axios.get("/consulta/rucdni", {
          params: {
            type,
            number
          }
        });

        const { nombre, direccion } = response.data;

        vm.form.name = nombre;
        vm.form.direction = direccion;

      } catch (error) {
        console.error({ error: error?.response || error });

        vm.$toast.fire({
          icon: "error",
          title: "Error al consultar los datos del documento"
        });
      } finally {
        vm.loading.rucdni = false;
      }
    }
  }
};
</script>
